<template>
  <split-view>
    <template #english>
      <div class="content">Glossary</div>
    </template>
    <template #chinese>
      <div class="content">Glossary</div>
    </template>
  </split-view>
</template>

<script>
const SplitView = () =>
  import(/* webpackChunkName: "View" */ "@/components/SplitView.vue");
import { mapState } from "vuex";
export default {
  name: "glossary",
  components: {
    SplitView,
  },
  metaInfo() {
    return {
      title: "– Glossary",
    };
  },
  created() {
    this.$store.dispatch("loadGlossary");
  },
  computed: mapState(["glossary"]),
};
</script>
